module.exports = __webpack_public_path__ + "static/media/puzzle-donut.6da49eb8.mp4";